export default __webpack_public_path__ + "static/media/perm.bd86044c.pdf";